import { addClass } from '../../assets/js/utility';

class Content {
  constructor() {
    // all content links and nav menu sublinks to apply external class to
    this.oldDomain = 'canadianenergycentre';
    this.externalClass = 'external';
    this.externalLinks = document.querySelectorAll(
      '.content a[href]:not(.button), .dynamic-nav a[href]'
    );

    if (this.externalLinks.length > 0) {
      for (let i = 0; i < this.externalLinks.length; i++) {
        let link = this.externalLinks[i];

        // exclude inline js, mailto, tel, etc links
        if (link.href.indexOf('://') > 0) {
          let hostnameParts = location.hostname.split('.');
          let rootDomain = hostnameParts[0];

          // location.hostname includes subdoms which we don't want to compare with
          // poor mans detection expecting simple subdom.rootdom.com format
          // what we want should be 2nd last unless on localhost
          if (hostnameParts.length > 1) {
            rootDomain = hostnameParts[hostnameParts.length - 2];
          }

          if (
            link.hostname.indexOf(rootDomain) < 0 &&
            link.hostname.indexOf(this.oldDomain) < 0
          ) {
            addClass(link, this.externalClass);
          }
        }
      }
    }

    if (this.mailToLinks && this.mailToLinks.length > 0) {
      this.mailtoWordBreak(this.mailToLinks);
    }
  }

  /**
   * Inserts a word break element after the @ symbol in a mailto link
   * @param {nodeList} elementList
   */
  mailtoWordBreak(elementList) {
    for (let element of elementList) {
      // some links are inside collapsed areas where grabbing innerText returns empty
      // and don't want to override any inner spans required for other component formatting
      const spanLayer = element.querySelector('span');
      const rawText = spanLayer?.textContent?.trim() ?? element.textContent.trim();

      const formatted = rawText.replace(/([@.])/g, '<wbr>$1');
      if (!formatted) {
        continue;
      }

      if (spanLayer) {
        spanLayer.innerHTML = formatted;
      } else {
        element.innerHTML = formatted;
      }
    }
  }
}

export default Content;
